module.exports = __webpack_public_path__ + "static/media/muay-thai-class-1.6736f488.jpeg";